enum UserType {
    SoleProprietor_LLC = 'SP-LLC',
    SoleProprietor_SCorp = 'SP-SC',
    LLC_SCorp = 'LLC-SC',
    LLC_LLC = 'LLC-LLC',
    SCorp_SCorp = 'SC-SC',
    SCorp_CCorp = 'SC-CC',
    SCorp_LLC = 'SC-LLC',
}

export default UserType;
